<template>
  <main class="about-info">
    <section class="hero">
      <div class="hero-box">
        <div class="hero-main">
          <div class="hero-label">关于清北博雅 · 品牌与服务介绍</div>
          <h1><span class="hero-line">围绕备考需求，</span><span class="hero-line">提供课程学习与<em>过程支持</em></span></h1>
          <p class="hero-copy">清北博雅始于2010年，面向研究生入学考试备考学员，提供公共课、专业方向、管理类硕士、复试调剂，以及线上与线下学习支持。</p>
          <div class="hero-actions">
            <a class="button primary" href="#courses" @click.prevent="scrollTo('courses')">了解课程方向</a>
            <a class="button secondary" href="#service" @click.prevent="scrollTo('service')">了解学习服务</a>
          </div>
          <p class="hero-note">具体课程、班型、课时、师资安排、费用与权益，以当期课程资料、双方约定及实际服务记录为准。</p>
        </div>
        <aside class="summary">
          <h2>清北博雅服务概览</h2>
          <div class="summary-item"><div class="summary-name">课程方向</div><div class="summary-value">公共课、专业方向、管理类硕士、复试与调剂相关支持</div></div>
          <div class="summary-item"><div class="summary-name">学习场景</div><div class="summary-value">线上课程、线下周末学习、线下集训及相应学习安排</div></div>
          <div class="summary-item"><div class="summary-name">过程支持</div><div class="summary-value">开课对接、学习规划、答疑测评、反馈处理等服务环节</div></div>
          <div class="summary-item"><div class="summary-name">报名前确认</div><div class="summary-value">科目、班型、课时、费用、服务项目与合同权益</div></div>
          <div class="summary-tags"><span>公共课</span><span>专业课</span><span>管硕</span><span>复试调剂</span><span>线下学习</span></div>
        </aside>
      </div>
      <div class="focus">
        <div class="focus-item"><div class="focus-title">课程方向</div><div class="focus-text">公共课、专业方向与管理类硕士等</div></div>
        <div class="focus-item"><div class="focus-title">学习形式</div><div class="focus-text">线上课程、线下课程与集训安排</div></div>
        <div class="focus-item"><div class="focus-title">服务环节</div><div class="focus-text">规划、答疑、测评与反馈处理</div></div>
        <div class="focus-item"><div class="focus-title">确认事项</div><div class="focus-text">课时、费用、班型与合同权益</div></div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="direct">
          <div class="direct-head"><div class="kicker">机构定位</div><h2>清北博雅<br>提供什么服务</h2></div>
          <div class="direct-body">
            <div class="answer"><strong>以考研课程学习和备考过程支持为主要服务内容</strong>清北博雅面向处于不同备考阶段的学员，围绕报考方向、学习科目与学习形式提供相应课程和服务说明。学员可在报名前了解课程安排、服务内容与权益约定，再结合自身基础、时间投入和目标方向作出选择。</div>
            <div class="small-grid">
              <div class="small-card"><h3>先确认科目</h3><p>明确报考方向与实际考试科目</p></div>
              <div class="small-card"><h3>再了解班型</h3><p>查看课程安排与服务配置差异</p></div>
              <div class="small-card"><h3>最后核对约定</h3><p>确认费用、权益和办理规则</p></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section advantages-v8">
      <div class="container">
        <div class="heading-row"><div><div class="kicker">清北博雅优势</div><h2>围绕备考过程，<br>提供课程与服务支持</h2></div><p class="intro">从课程教学、师资配置到学习过程中的答疑、督学与反馈支持，清北博雅围绕学员在不同备考阶段的实际需要设置相应服务。</p></div>
        <div class="strengths">
          <article class="strength service-v8">
            <div class="strength-top"><div><div class="strength-index">01 / 学员服务</div><h3>5V1角色协同服务</h3><p class="strength-desc">5V1由不同服务角色共同参与学习支持，每类角色对应具体工作内容，帮助学员衔接课程学习、日常执行、问题答疑和服务反馈。</p></div></div>
            <div class="role-row">
              <div class="role-v8"><b>班主任老师</b><span>学习对接、计划与节奏沟通、日常回访及过程协调</span></div>
              <div class="role-v8"><b>学研老师</b><span>同步备考干货、学习技巧、热点信息与学习内容</span></div>
              <div class="role-v8"><b>学管老师</b><span>参与打卡、背诵抽查、活动提醒与执行支持</span></div>
              <div class="role-v8"><b>答疑老师</b><span>解答知识点、题目与课程学习中的疑问</span></div>
              <div class="role-v8"><b>客服老师</b><span>接收服务意见与反馈，协助后续沟通衔接</span></div>
            </div>
            <p class="service-tip">具体服务角色与配置以所报班次及实际服务安排为准。</p>
          </article>
          <article class="strength faculty-v8">
            <div class="faculty-layout">
              <div class="faculty-heading"><div class="strength-index">02 / 课程师资</div><h3>多方向课程师资</h3><p>根据课程方向设置相应授课与教研安排，以下为当前课程资料中展示的师资信息。</p></div>
              <div>
                <div class="faculty-list">
                  <div class="faculty-row"><div class="faculty-subject">英语师资</div><div class="faculty-tags"><span>唐迟</span><span>章晋林</span><span>邵宁</span><span>刘晓艳</span></div></div>
                  <div class="faculty-row"><div class="faculty-subject">数学师资</div><div class="faculty-tags"><span>崔恒斌</span><span>余丙森</span></div></div>
                  <div class="faculty-row"><div class="faculty-subject">政治师资</div><div class="faculty-tags"><span>米鹏</span><span>关宝瑞</span></div></div>
                  <div class="faculty-row"><div class="faculty-subject">管综师资</div><div class="faculty-tags"><span>陈剑</span><span>韩毓</span><span>孙勇</span><span>陈君华</span><span>珊珊老师</span></div></div>
                  <div class="faculty-row"><div class="faculty-subject">其他专业课</div><div class="faculty-tags"><span>刘纬宇（396）</span><span>韩奕（396）</span><span>王帅（396）</span><span>刘老师（408）</span><span class="text-tag">清北博雅计算机团队</span><span class="text-tag">目标院校专业学长学姐</span></div></div>
                </div>
                <p class="faculty-note">其他专业课方向及具体任课安排，请以对应课程详情和当期教务通知为准。</p>
              </div>
            </div>
          </article>
          <div class="strength-bottom">
            <article class="strength course-v8"><div class="strength-index">03 / 课程体系</div><h3>分阶段组织备考内容</h3><p class="strength-desc">围绕公共课、管理类硕士与专业方向设置课程内容，按学习进程组织相应阶段课程与训练。</p><div class="stage-row"><span>基础夯实</span><span>强化提升</span><span>真题训练</span><span>冲刺复习</span><span>复试衔接</span></div><p class="coverage">覆盖公共课、管综、教育综合、396经综、408计算机、法硕、农业硕士及专业课一对一等方向。</p></article>
            <article class="strength result-v8"><div class="strength-index">04 / 过往成果</div><h3>历史成果信息展示</h3><div class="result-inner"><div class="result-number">68%</div><div class="result-label">985、211上岸通过率历史展示</div></div><p class="strength-desc">同时可在相关成果内容中了解过往录取案例与学员学习反馈。</p><p class="result-boundary">过往数据与案例不构成对个人考试成绩或录取结果的承诺。</p></article>
          </div>
        </div>
      </div>
    </section>

    <section class="section" id="courses">
      <div class="container">
        <div class="kicker">课程方向</div><h2>根据备考方向了解课程</h2>
        <p class="section-intro">课程方向及招生安排会随年度与具体产品更新。下列内容用于说明官网当前重点覆盖的学习方向，具体招生班型请进入课程详情页了解。</p>
        <div class="courses">
          <article class="course"><h3>公共课</h3><p>政治、英语、数学等公共课课程方向。</p><p class="minor">适合希望系统推进公共课学习节奏的学员</p></article>
          <article class="course"><h3>管理类硕士</h3><p>笔试、面试及笔面衔接相关课程方向。</p><p class="minor">适合关注管综、英语与复试准备的学员</p></article>
          <article class="course"><h3>专业与专项方向</h3><p>教育综合、396经综、408计算机、农业硕士、法硕及专业课一对一等。</p><p class="minor">以对应课程说明和招生安排为准</p></article>
          <article class="course"><h3>复试与线下学习</h3><p>复试相关支持、线下周末课程与线下集训学习场景。</p><p class="minor">适合关注学习环境与过程支持的学员</p></article>
        </div>
        <div class="notice">课程方向会对应不同的班型、授课安排与服务项目。课时、师资安排、费用、资料配置及具体权益，请以当前课程详情、双方约定和实际服务记录为准。</div>
      </div>
    </section>

    <section class="section process-section" id="service">
      <div class="container">
        <div class="kicker kicker-light">学习服务</div><h2>从报名确认到学习反馈</h2>
        <p class="intro intro-light">不同课程与班型的实际服务配置可能不同，以下流程用于帮助学员了解一般的学习服务环节。</p>
        <div class="process">
          <article class="step"><b>1</b><h3>报名前了解</h3><p>确认专业、科目、学习形式、课程安排与相关权益。</p></article>
          <article class="step"><b>2</b><h3>课程开通</h3><p>按照已开通课程和班次安排进入相应学习环节。</p></article>
          <article class="step"><b>3</b><h3>学习支持</h3><p>依据实际班型获得规划、答疑、测评或督学等支持。</p></article>
          <article class="step"><b>4</b><h3>反馈与办理</h3><p>就学习服务、权益事项或办理需求按对应渠道沟通。</p></article>
        </div>
        <div class="service-links">
          <strong>相关说明入口</strong>
          <router-link :to="{ name: 'NewsShow', params: { id: 'serviceDescription' } }">课程开通与学习服务</router-link>
          <router-link :to="{ name: 'NewsShow', params: { id: 'feedbackInstructions' } }">学习服务反馈与处理</router-link>
          <router-link :to="{ name: 'NewsShow', params: { id: 'rightsProtection' } }">重修或保障权益</router-link>
          <router-link :to="{ name: 'NewsShow', params: { id: 'refundPolicy' } }">课程退费办理</router-link>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="kicker">报名前确认</div><h2>选择课程时建议关注什么</h2>
        <p class="section-intro">选择课程前，可结合自身情况与具体课程说明逐项确认，避免只凭单一信息作出判断。</p>
        <div class="confirm">
          <div class="panel"><h3>结合自身需求了解课程</h3><ul class="checks"><li>目标专业、考试科目与当前复习阶段。</li><li>线上、线下或集训类学习场景是否适合自己的时间。</li><li>是否需要学习规划、答疑、测评或更具体的过程支持。</li><li>课程内容能否回应目前最需要解决的学习问题。</li></ul></div>
          <div class="panel panel-alt"><h3>办理前核对具体约定</h3><ul class="checks"><li>所选班型包含的课程、资料与服务项目。</li><li>课时、授课安排、费用与服务周期。</li><li>是否涉及一对一、复试、重修或其他约定权益。</li><li>退费、保障权益及反馈办理的合同约定和流程说明。</li></ul></div>
        </div>
      </div>
    </section>

    <section class="section public">
      <div class="container">
        <div class="kicker">公开信息</div><h2>官网公开信息与查询说明</h2>
        <p class="section-intro">这里展示清北博雅相关网站的备案、许可证及部分品牌荣誉信息，便于学员和家长了解机构信息。</p>
        <div class="public-grid">
          <div class="info-card">
            <article class="record"><div class="record-label">ICP备案信息</div><h3>清北博雅（武汉）教育科技有限公司</h3><p>对应网站域名为 <strong>www.qbbystudy.com</strong>，网站服务备案号为 <strong> 鄂ICP备2023015012号-1</strong>。</p></article>
            <article class="record"><div class="record-label">网络文化经营许可证信息</div><h3>清北博雅（武汉）教育科技有限公司</h3><p>关联网站域名为 <strong>qbbystudy.com</strong>，许可证编号为 <strong>鄂网文〔2024〕1420-120号</strong>，证载有效期至 <strong>2027年04月01日</strong>。</p></article>
            <article class="record"><div class="record-label">品牌与行业荣誉</div><h3>荣誉材料展示</h3><div class="honor-list">
              <div class="honor"><div class="honor-title">2024年度考研教育领导力品牌</div><div class="honor-sub">荣誉材料所载主体：清北博雅教育集团｜颁发方：新浪教育、微博教育</div></div>
              <div class="honor"><div class="honor-title">中国3.15诚信品牌</div><div class="honor-sub">荣誉材料所载主体：北京清北博雅教育咨询有限公司</div></div>
              <div class="honor"><div class="honor-title">中国考研培训行业最具影响力品牌</div><div class="honor-sub">荣誉材料所载主体：北京清北博雅教育咨询有限公司</div></div>
            </div></article>
          </div>
          <aside class="guide">
            <h3>继续了解课程与服务</h3>
            <p class="guide-lead">了解机构公开信息后，报名前还可以结合自己的备考方向，重点查看以下内容。</p>
            <div class="guide-item"><b>课程方向</b><p>根据考试科目，了解公共课、管理类硕士或对应专业方向课程。</p></div>
            <div class="guide-item"><b>学习形式</b><p>查看线上课程、线下课程或集训类学习安排是否适合自己的时间。</p></div>
            <div class="guide-item"><b>服务支持</b><p>了解课程开通、学习规划、答疑反馈及相关办理说明。</p></div>
            <div class="guide-item"><b>报名确认</b><p>确认班型、课时、费用、授课安排与合同权益后再作选择。</p></div>
            <div class="guide-actions"><a href="#courses" @click.prevent="scrollTo('courses')">查看课程方向</a><a href="#service" @click.prevent="scrollTo('service')">查看学习服务</a></div>
            <div class="guide-note">具体课程内容、费用与服务权益，以对应课程说明和双方约定为准。</div>
          </aside>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="faq-grid">
          <div><div class="kicker">常见问答</div><h2>了解清北博雅时<br>常见的问题</h2><p class="section-intro">围绕课程、服务、报名确认和公开信息，提供便于查阅的基础说明。</p></div>
          <div class="faqs">
            <details open><summary>清北博雅考研主要提供哪些服务？</summary><p>清北博雅围绕研究生入学考试备考提供课程学习与过程支持，课程方向包括公共课、专业方向、管理类硕士、复试与调剂，以及线上与线下学习场景。具体服务内容以当前课程说明和双方约定为准。</p></details>
            <details><summary>怎样选择适合自己的课程或班型？</summary><p>建议先确认目标专业、考试科目、学习基础、备考时间和所需的支持方式，再查看对应课程和班型说明。不同课程与班型的服务内容和权益安排应分别确认。</p></details>
            <details><summary>报名后如何开始学习，遇到问题联系谁？</summary><p>报名后按照已开通课程和所在班次安排开始学习。题目疑问、学习计划或服务反馈等事项，可依实际服务配置联系答疑老师、班主任或对应服务渠道。</p></details>
            <details><summary>课程是否承诺录取结果或固定退费结果？</summary><p>课程和学习服务用于提供备考支持，不构成录取、通过或固定分数结果承诺。涉及退费、重修或其他保障事项时，应根据实际班型、合同约定、订单记录和服务记录核对办理。</p></details>
            <details><summary>官网展示的备案与许可证信息如何理解？</summary><p>备案与许可证信息用于说明材料载明的主体、关联域名、编号与期限。不同主体的信息应分别查看，且此类信息不等同于课程质量认证或考试结果承诺。</p></details>
          </div>
        </div>
      </div>
    </section>

    <section class="meta">
      <div class="container">
        <div class="meta-line"><span>发布时间：2026年06月02日</span><span>更新时间：2026年06月02日</span><span>所属栏目：关于清北博雅 / 品牌介绍</span></div>
        <div class="statement">本页用于介绍清北博雅的课程方向、学习服务路径与官网公开信息。具体课程、班型、课时、师资安排、价格、资料配置、退费、重修或其他保障权益，以当期课程资料、双方约定、订单记录与实际服务记录为准。实际备考结果受学员基础、学习投入、目标院校要求、考试发挥与招生政策等因素影响。</div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "AboutInfo",
  methods: {
    scrollTo(id) {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>

<style scoped>
.about-info {
  --red: #8c0b18; --red-dark: #61030d; --red-mid: #a81728; --red-soft: #fbf1f2;
  --bg: #fbf8f5; --ink: #282224; --body: #6d6062; --muted: #9d9092; --line: #ead7d8;
  --white: #fff; --gold: #c7a25b; --shadow: 0 22px 54px rgba(93,16,23,.10);
  --max: 1180px;
  color: var(--ink);
  font-family: "Microsoft YaHei","PingFang SC","Noto Sans SC",Arial,sans-serif;
  line-height: 1.75;
  background: var(--bg);
}
p,h1,h2,h3,h4 { margin: 0; }
h1,h2,h3,h4 { font-weight: 700; line-height: 1.28; letter-spacing: -.035em; }
b,strong { font-weight: 700; }
.container { width: min(100%, var(--max)); margin: 0 auto; padding: 0 24px; }

.hero { padding: 20px 24px 0; }
.hero-box {
  border-radius: 30px; overflow: hidden; isolation: isolate; position: relative; color: #fff;
  background: linear-gradient(116deg,#61030d 0%,#8c0b18 52%,#a81728 100%);
  padding: 62px 60px 58px; display: grid; grid-template-columns: 1.12fr .88fr; gap: 38px;
}
.hero-box::before {
  content:""; position:absolute; right:-225px; bottom:-300px; width:790px; height:790px; border-radius:50%;
  border:1px solid rgba(255,255,255,.12);
  box-shadow:0 0 0 30px rgba(255,255,255,.045),0 0 0 60px rgba(255,255,255,.038),0 0 0 90px rgba(255,255,255,.03),0 0 0 120px rgba(255,255,255,.023);
  pointer-events:none;
}
.hero-label { font-size:13px; letter-spacing:.2em; font-weight:700; color:#f3d7da; margin-bottom:22px; }
.hero h1 { font-size:clamp(39px,3.35vw,48px); line-height:1.21; margin-bottom:25px; letter-spacing:-.055em; }
.hero-line { display:block; }
.hero h1 em { font-style:normal; color:#f5dfd2; }
.hero-copy { font-size:17px; color:rgba(255,255,255,.87); line-height:1.95; max-width:606px; }
.hero-actions { display:flex; gap:13px; margin-top:36px; }
.button { height:48px; border-radius:25px; padding:0 26px; display:inline-flex; align-items:center; justify-content:center; font-size:15px; font-weight:700; transition:.2s ease; text-decoration:none; }
.button:hover { transform:translateY(-1px); }
.primary { background:white; color:#8c0b18; }
.secondary { border:1px solid rgba(255,255,255,.43); color:white; background:rgba(255,255,255,.04); }
.hero-note { margin-top:25px; font-size:12px; line-height:1.8; color:rgba(255,255,255,.65); max-width:612px; }
.summary { align-self:stretch; border-radius:24px; background:rgba(255,255,255,.10); border:1px solid rgba(255,255,255,.24); padding:30px 29px 27px; display:flex; flex-direction:column; }
.summary h2 { font-size:23px; margin-bottom:19px; }
.summary-item { padding:15px 0; border-top:1px solid rgba(255,255,255,.17); }
.summary-item:first-of-type { border-top:0; padding-top:4px; }
.summary-name { font-size:13px; font-weight:700; color:#f3dde0; margin-bottom:5px; }
.summary-value { font-size:14px; line-height:1.7; color:rgba(255,255,255,.9); }
.summary-tags { display:flex; flex-wrap:wrap; gap:8px; margin-top:auto; padding-top:22px; }
.summary-tags span { padding:6px 11px; border-radius:18px; background:rgba(255,255,255,.12); font-size:12px; color:#fff; }
.focus { margin:-27px auto 0; background:#fff; border-radius:19px; box-shadow:var(--shadow); padding:23px 30px; position:relative; z-index:2; display:grid; grid-template-columns:repeat(4,1fr); max-width:var(--max); }
.focus-item { padding:0 23px; border-left:1px solid var(--line); }
.focus-item:first-child { border-left:0; padding-left:7px; }
.focus-title { font-size:20px; color:#8c0b18; font-weight:700; margin-bottom:4px; }
.focus-text { font-size:13px; color:var(--muted); line-height:1.55; }

.section { padding:78px 0; }
.section-intro { font-size:16px; color:var(--body); margin-top:14px; max-width:780px; }
.kicker { font-size:13px; color:#8c0b18; font-weight:700; letter-spacing:.17em; display:flex; align-items:center; gap:10px; }
.kicker::before { content:""; width:26px; height:2px; background:#8c0b18; }
.kicker-light { color:#f1d0d3; }
.kicker-light::before { background:#f1d0d3; }
.section h2 { font-size:clamp(30px,3vw,41px); margin-top:15px; }

.direct { display:grid; grid-template-columns:.62fr 1.38fr; gap:56px; align-items:start; }
.answer { background:var(--red-soft); border-left:4px solid #8c0b18; border-radius:0 18px 18px 0; padding:29px 33px; color:var(--body); font-size:16px; }
.answer strong { display:block; color:#61030d; font-size:21px; margin-bottom:9px; }
.small-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:13px; margin-top:20px; }
.small-card { border:1px solid var(--line); border-radius:15px; background:white; padding:18px 17px; }
.small-card h3 { font-size:15px; margin-bottom:5px; }
.small-card p { font-size:13px; color:var(--muted); line-height:1.6; }

.advantages-v8 { background:#faf6f5; }
.heading-row { display:flex; align-items:end; justify-content:space-between; gap:32px; margin-bottom:36px; }
.heading-row .intro { margin:0; max-width:545px; font-size:16px; color:var(--body); }
.strengths { display:grid; gap:18px; }
.strength { background:#fff; border:1px solid #efe3e4; border-radius:22px; padding:30px 32px; }
.strength-top { display:flex; align-items:flex-start; justify-content:space-between; gap:28px; margin-bottom:22px; }
.strength-index { color:#8c0b18; font-size:12px; line-height:1; font-weight:700; letter-spacing:.16em; margin-bottom:14px; }
.strength h3 { font-size:25px; margin-bottom:9px; }
.strength-desc { color:var(--body); font-size:14px; max-width:710px; }
.service-v8 { background:linear-gradient(110deg,#fff 0%,#fff 56%,#fff9f8 100%); }
.role-row { display:grid; grid-template-columns:repeat(5,minmax(0,1fr)); gap:10px; }
.role-v8 { min-height:116px; padding:15px 14px; background:#fff; border:1px solid #eddcdf; border-radius:14px; }
.role-v8 b { display:block; color:#8c0b18; font-size:14px; margin-bottom:7px; }
.role-v8 span { display:block; color:var(--body); font-size:12px; line-height:1.65; }
.service-tip { margin-top:16px; color:var(--muted); font-size:12px; }
.faculty-v8 { padding-bottom:27px; }
.faculty-layout { display:grid; grid-template-columns:258px 1fr; gap:32px; align-items:start; }
.faculty-heading { padding-right:24px; border-right:1px solid var(--line); display:flex; flex-direction:column; align-self:stretch; }
.faculty-heading p { font-size:14px; color:var(--body); margin-top:10px; }
.faculty-list { display:grid; gap:9px; }
.faculty-row { min-height:54px; display:grid; grid-template-columns:118px 1fr; align-items:center; gap:14px; border-radius:13px; background:#fcf8f8; border:1px solid #f0e4e5; padding:9px 13px; }
.faculty-subject { font-size:14px; font-weight:700; color:#8c0b18; }
.faculty-tags { display:flex; gap:7px; flex-wrap:wrap; }
.faculty-tags span { display:inline-flex; align-items:center; height:29px; padding:0 12px; border-radius:16px; background:#fff; color:#34383f; border:1px solid #eedfe1; font-size:13px; font-weight:600; }
.faculty-tags .text-tag { color:var(--body); font-weight:500; }
.faculty-note { font-size:12px; color:var(--muted); margin-top:14px; }
.strength-bottom { display:grid; grid-template-columns:1fr 1fr; gap:18px; }
.course-v8,.result-v8 { padding:29px 30px; min-height:235px; display:flex; flex-direction:column; }
.stage-row { display:flex; gap:8px; flex-wrap:wrap; margin:20px 0 16px; }
.stage-row span { border-radius:16px; padding:5px 12px; color:#8c0b18; background:var(--red-soft); font-size:13px; font-weight:650; }
.coverage { margin-top:auto; color:var(--body); font-size:13px; border-top:1px solid var(--line); padding-top:13px; }
.result-inner { display:flex; align-items:end; gap:14px; margin:17px 0 14px; }
.result-number { font-size:56px; line-height:.92; font-weight:750; letter-spacing:-.06em; color:#8c0b18; }
.result-label { font-size:14px; color:var(--body); padding-bottom:5px; }
.result-boundary { margin-top:auto; border-top:1px solid var(--line); padding-top:13px; color:var(--muted); font-size:12px; }

.courses { display:grid; grid-template-columns:repeat(4,1fr); gap:17px; margin-top:36px; }
.course { border:1px solid var(--line); background:#fff; border-radius:20px; padding:25px 22px; min-height:211px; }
.course h3 { font-size:19px; color:#8c0b18; margin-bottom:11px; }
.course p { font-size:14px; color:var(--body); }
.course .minor { font-size:12px; color:var(--muted); margin-top:18px; line-height:1.65; }
.notice { margin-top:26px; border-radius:15px; background:#fff7f7; border:1px solid #ecd9dc; padding:17px 21px; color:#67595b; font-size:14px; }

.process-section { background:#61030d; color:white; }
.process-section .intro { color:rgba(255,255,255,.74); font-size:16px; }
.process { display:grid; grid-template-columns:repeat(4,1fr); gap:16px; margin-top:37px; }
.step { padding:25px 21px 23px; border:1px solid rgba(255,255,255,.16); border-radius:19px; background:rgba(255,255,255,.045); }
.step b { display:grid; place-items:center; width:34px; height:34px; border-radius:50%; background:white; color:#8c0b18; margin-bottom:18px; }
.step h3 { font-size:18px; margin-bottom:9px; }
.step p { font-size:14px; color:rgba(255,255,255,.76); }
.service-links { margin-top:28px; background:rgba(255,255,255,.08); border-radius:16px; padding:18px 22px; display:flex; align-items:center; gap:20px; font-size:14px; flex-wrap:wrap; }
.service-links strong { font-size:15px; }
.service-links a { border:1px solid rgba(255,255,255,.21); border-radius:18px; padding:5px 12px; color:rgba(255,255,255,.89); text-decoration:none; transition:background .2s; }
.service-links a:hover { background:rgba(255,255,255,.12); }

.confirm { display:grid; grid-template-columns:1fr 1fr; gap:19px; margin-top:34px; }
.panel { border:1px solid var(--line); border-radius:21px; padding:30px 29px; background:white; }
.panel-alt { background:var(--red-soft); border-color:transparent; }
.panel h3 { font-size:22px; margin-bottom:18px; }
.checks { list-style:none; margin:0; padding:0; display:grid; gap:13px; }
.checks li { display:flex; gap:11px; color:var(--body); font-size:15px; align-items:flex-start; }
.checks li::before { content:""; flex:none; width:7px; height:7px; background:#8c0b18; border-radius:50%; margin-top:10px; }

.public { background:#faf6f5; }
.public-grid { display:grid; grid-template-columns:1.06fr .94fr; gap:22px; margin-top:35px; align-items:stretch; }
.info-card { background:white; border:1px solid var(--line); border-radius:23px; padding:31px 32px; }
.record { padding:0 0 23px; margin-bottom:23px; border-bottom:1px solid var(--line); }
.record:last-child { padding:0; margin:0; border:0; }
.record-label { font-size:13px; color:#8c0b18; font-weight:700; margin-bottom:8px; }
.record h3 { font-size:19px; margin-bottom:7px; }
.record p { font-size:14px; color:var(--body); }
.record p strong { font-weight:700; }
.guide { background:#8c0b18; border-radius:23px; color:white; padding:31px 30px; display:flex; flex-direction:column; }
.guide h3 { font-size:26px; margin-bottom:12px; }
.guide-lead { font-size:14px; color:rgba(255,255,255,.83); line-height:1.75; margin:0 0 15px; }
.guide-actions { display:flex; gap:10px; flex-wrap:wrap; margin-top:20px; padding-top:5px; }
.guide-actions a { display:inline-flex; align-items:center; height:38px; padding:0 16px; border-radius:20px; background:#fff; color:#8c0b18; font-size:13px; font-weight:700; text-decoration:none; transition:opacity .2s; }
.guide-actions a:hover { opacity:.9; }
.guide-item { padding:16px 0; border-top:1px solid rgba(255,255,255,.17); display:grid; grid-template-columns:104px 1fr; gap:13px; }
.guide-item b { font-size:13px; color:#f5dfe1; }
.guide-item p { font-size:13px; color:rgba(255,255,255,.84); line-height:1.65; }
.guide-note { margin-top:auto; padding-top:17px; border-top:1px solid rgba(255,255,255,.17); font-size:12px; color:rgba(255,255,255,.78); line-height:1.75; }

.honor-list { display:grid; gap:10px; margin-top:19px; }
.honor { padding:14px 14px; border:1px solid var(--line); border-radius:13px; background:#fff; }
.honor-title { font-size:14px; font-weight:700; color:var(--ink); line-height:1.45; }
.honor-sub { font-size:12px; color:var(--muted); line-height:1.55; margin-top:4px; }

.faq-grid { display:grid; grid-template-columns:.62fr 1.38fr; gap:53px; }
.faqs { display:grid; gap:11px; }
details { border:1px solid var(--line); border-radius:15px; background:white; padding:0 21px; }
summary { position:relative; list-style:none; cursor:pointer; padding:19px 32px 19px 0; font-size:16px; font-weight:700; color:#61030d; }
summary::-webkit-details-marker { display:none; }
summary::after { content:"＋"; position:absolute; right:0; color:#8c0b18; font-size:18px; }
details[open] summary::after { content:"－"; }
details p { font-size:14px; color:var(--body); padding:0 0 19px; }

.meta { border-top:1px solid var(--line); padding:32px 0 43px; color:var(--muted); font-size:13px; }
.meta-line { display:flex; flex-wrap:wrap; gap:25px; margin-bottom:14px; }
.statement { background:#f8f3f2; color:#625658; border-radius:14px; padding:17px 21px; line-height:1.85; }

@media (max-width:1120px) {
  .hero-box{grid-template-columns:1fr;min-height:0;padding:50px 42px}
  .summary{max-width:650px}
  .focus{grid-template-columns:repeat(2,1fr)}
  .direct,.public-grid,.faq-grid{grid-template-columns:1fr}
  .courses,.process{grid-template-columns:repeat(2,1fr)}
  .role-row{grid-template-columns:repeat(2,minmax(0,1fr))}
  .faculty-layout{grid-template-columns:1fr;gap:20px}
  .faculty-heading{padding-right:0;border-right:0}
}
@media (max-width:720px) {
  .hero-box{padding:40px 23px 35px;border-radius:22px;gap:29px}
  .hero h1{font-size:35px}
  .hero-copy{font-size:15px}
  .hero-actions{display:grid}
  .focus{grid-template-columns:1fr;padding:10px 21px;margin-top:-15px}
  .focus-item{padding:15px 0;border-left:0;border-top:1px solid var(--line)}
  .focus-item:first-child{border-top:0;padding-left:0}
  .section{padding:56px 0}
  .courses,.process,.confirm,.small-grid{grid-template-columns:1fr}
  .strength{padding:25px 20px}
  .strength-top{display:block}
  .role-row,.strength-bottom{grid-template-columns:1fr}
  .faculty-row{grid-template-columns:1fr;gap:7px;padding:13px}
  .course-v8,.result-v8{min-height:0}
  .heading-row{display:block}
  .heading-row .intro{margin-top:13px}
  .info-card,.guide,.panel{padding:24px 21px}
  .guide-item{grid-template-columns:1fr;gap:4px}
}
</style>
